import { useEffect, useState } from 'react';

const useNetworkListener = () => {
  const [isOffline, setIsOffline] = useState(false);

  const setOffline = () => setIsOffline(true);
  const setOnline = () => setIsOffline(false);

  useEffect(() => {
    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);

    return () => {
      window.removeEventListener('online', setOnline);
      window.removeEventListener('offline', setOffline);
    };
  }, []);

  return isOffline;
};

export default useNetworkListener;
